import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Observable, catchError, delay, forkJoin, of, firstValueFrom, lastValueFrom, switchMap, retry, throwError, timer, map } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActionPlanService } from '../../services/action-plan.service';
import { ActionItemConstants } from '../../constants/action-item-constants';
import { ChangeControlActionPlan } from '../../models/change-control-action-plan';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ChangeControlActionItem } from '../../models/change-control-action-item';
import { ActionItemDetails } from '../../models/action-item-details';
import { DatePipe } from '@angular/common';
import { ExtendedActionItem } from '../../models/extend-action-item';
import { ActionItemAttachmentDetails } from '../../models/action-item-attachment-details';
import { ActionPlanDetails } from '../../models/action-plan-details';
import { ChangeManagementConstant } from '../../constants/changeManagementConstants';
import { ChangeControlPersistenceService } from '../../services/change-control-persistence.service';
import { UserType } from '../../../../../app/shared/enums/user-type';
import { UsersService } from '../../../../../app/shared/services/users.service';
import { AssignmentGroupSharedDataService } from '../../../../../app/shared/services/assignment-group-shared-data.service';
import { CustomError } from '../../../../../app/shared/models/error/custom-error';
import { SharedConstants } from '../../../../../app/shared/constants/shared-constants';
import { CommonService } from '../../../../../app/shared/services/common.service';
import { ActionItemStatus } from '../../enums/action-item-status';
import { DialogComponent } from '../../../../../app/shared/components/dialog/dialog.component';

@Component({
  selector: 'app-action-item-slider',
  templateUrl: './action-item-slider.component.html',
  styleUrls: ['./action-item-slider.component.scss']
})

export class ActionItemSliderComponent implements OnInit{
  @Output() isSliderActive = new EventEmitter<boolean>();
  @Output() closeActionItemSlider = new EventEmitter<boolean>();
  @Input() changeControlNumber: any = '';
  @Input() isActionItemSliderOpen: boolean = false;
  @Input() scopes: number[] = [];
  @Input() event: string = '';
  @Input() actionItemDetails: ActionItemDetails = {} as ActionItemDetails;
  @Output() updatedActionPlan = new EventEmitter<ActionPlanDetails>();
  @Input() lastActionItemNumber?: string;
  maxFileSize = ActionItemConstants.Attachment_File_Max_Size;
  actionItemForm!: FormGroup;
  sliderHeaderText = ChangeManagementConstant.CreateActionItem_Title;
  typeOptions: any = [];
  assigneeOptions: any = [];
  verifierOptions: any = [];
  usersList: any = []; 
  attachmentsToSave: File[] = [];
  attachmentsUploaded: any[] = [];
  valueField: string = 'value';
  labelField: string = 'name';
  infoForRiskAssessmentRequired = ActionItemConstants.ActionItem_TooltipForRiskAssessmentRequired;
  infoForVerificationRequired = ActionItemConstants.ActionItem_TooltipForVerificationRequired;
  attachmentFileTypes = '';
  errorMessages: any = [];
  mandatoryFields = this.getDefaultMandatoryFieldsObject();
  actionItemsRequest!: ChangeControlActionPlan;
  isVerifierRequired : boolean = false;
  errorHeading: string = ActionItemConstants.ActionItem_Error_Heading;
  fileNamesToSave: string[] = [];
  uploadResponses: any = [];
  actionItemFilesResponses: any = [];
  extendActionItem : ExtendedActionItem = {} as ExtendedActionItem;
  isEditSlider: boolean = false;
  actionItemAttachmentDetails: ActionItemAttachmentDetails[] | null = [];
  attachmentData: any = null;
  deletedAttachmentFileIds: string[] = [];

  verifiersList:any=[];
  assigneeList:any=[];
  verifiersWithInactiveUsersList:any=[];
  assigneeWithInactiveUsersList:any=[];
  usersListToValidate:any=[];
  validatedUsersList:any=[];
  inactiveUserSelected:any;
  inactiveGroupsSelected:any;
  isInActiveAssignmentGroupDialog:boolean = false;
  InactiveAssignmentGroupField = '';
  actionPlanId!: any;
  actionItemIds!: any[];
  actionItemSliderLoader: boolean = false;
  keepSliderOpenAfterUpdate: boolean = false;

  // Set when the Action Item is awaiting verification and only the Verifier can be changed
  isVerifierOnlyEdit: boolean = false;
  isReasonForChangeRequired: boolean = false;
  reasonForChange: string = '';
  reasonHeading: string = ActionItemConstants.ActionItem_ReasonForChange_Heading;
  reasonValidationMessage: string = ActionItemConstants.ActionItem_ReasonForChange_Required;
  @ViewChild(DialogComponent) reasonDialog?: DialogComponent;

  constructor(private actionPlanService: ActionPlanService,
    private formBuilder: FormBuilder,
    private messageService: MessageService,public datepipe: DatePipe, 
    private changeControlPersistenceService: ChangeControlPersistenceService,
    private confirmationService: ConfirmationService,
    private usersService: UsersService,
    private assignmentGroupSharedDataService: AssignmentGroupSharedDataService,
    private commonService: CommonService
    ) {

  }

  ngOnInit() {
    this.actionItemForm = this.createFormGroupWithBuilderAndModel();    
    this.verificationCheckboxChange();
    this.actionItemForm.controls['verifier'].disable();
    this.getInitialData();
  }
  createFormGroupWithBuilderAndModel() {
    return this.formBuilder.group({
      title: new FormControl(null, [Validators.required]),
      type: new FormControl(null, [Validators.required]),
      description: new FormControl(null, [Validators.required]),
      dueDate: new FormControl(null, [Validators.required]),
      isRiskAssessmentRequired: new FormControl(false, [Validators.required]),
      isVerificationRequired: new FormControl(false, [Validators.required]),
      assignees: new FormControl(null, [Validators.required]),
      verifier: new FormControl(null, [Validators.required]),
      verificationNotes: new FormControl(null, [Validators.required]),
      actionTaken: new FormControl(null, [Validators.required])
    })
  }

  getInitialData() {
    this.actionPlanService.getTypes()
      .subscribe(typesData => this.typeOptions = typesData);

      this.changeControlPersistenceService.updateScopesOnChangeControlUpdate()
        .subscribe((scopes : number[] | null) => this.updateScopesOnChangeControlUpdate(scopes)); 

      this.getUserLookUpData(this.scopes, false);

  }

  getUserLookUpData(scopes: number[], scopeChange: boolean){
    this.actionPlanService.getUsersLookUpData(this.scopes, scopeChange)
    .subscribe(async usersData => {
      this.usersList = [];
     for (let dataItem of usersData) {
       this.usersList.push({
         value: dataItem.name,
         name: dataItem.name,
       });
     }
     this.verifiersList=[...this.usersList];
     this.assigneeList=[...this.usersList];

     if(this.checkValidity(this.event) && (this.event == ActionItemConstants.ActionItem_SpeedDialButton_Edit || this.event == ActionItemConstants.ActionItem_SpeedDialButton_EditForAssignee)){
      await this.setDataForEdit();
     }
   });
  }

  uploadSuccess = (files: File[]): Observable<string[]> => {
  this.attachmentsToSave = [...this.attachmentsToSave, ...files];
  this.fileNamesToSave = this.attachmentsToSave.map((file) => file.name);
  const fileNames = files.map((file) => file.name);
  return of(fileNames).pipe(delay(3000));
}

  // called by upload when a pending (not yet saved) file is removed via X button.
  deleteFile = (fileName: string): Observable<boolean> => {
    this.attachmentsToSave = this.attachmentsToSave.filter((file) => file.name !== fileName);
    this.fileNamesToSave = this.fileNamesToSave.filter((name) => name !== fileName);
    return of(true);
  }

  closeSlider() {
    this.confirmationService.confirm({
      message: ActionItemConstants.ActionItemClose_ConfirmationMessage,
      header: ActionItemConstants.Confirmation_Header,
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.isActionItemSliderOpen = false;
        this.resetActionItemForm();
        this.isSliderActive.emit(this.isActionItemSliderOpen);
      },
      reject: () => {},
    });
  }

  async saveFiles(): Promise<void> {
  // If New File is Uploaded in Attachment Material
  if (this.attachmentsToSave.length !== 0) {
    const uploadResults = await Promise.all(
      this.attachmentsToSave.map((file: File) => this.updateAttachments(file))
    );

    const hasUploadFailures = uploadResults.some((result) => result === false);

    // Determine the next action only once, after all uploads
    this.determineAction(hasUploadFailures);
  }
}

async updateAttachments(file: File): Promise<boolean> {
  const modifiedFile = new File(
    [file], 
    this.extendActionItem.actionItemNumber + '/' + file.name, 
    { type: file.type }
  );
  
  return lastValueFrom(
    this.actionPlanService.uploadFile(
      modifiedFile, 
      ActionItemConstants.ActionItem_Attachments_FolderName
    )
  )
    .then((response) => {
      if (!this.extendActionItem?.attachments) {
        this.extendActionItem.attachments = [];
      }

        const exists = this.extendActionItem.attachments.some(
        (data: any) => data.attachmentName === file.name
      );

      if (!exists) {
        this.extendActionItem.attachments.push(
          this.constructActionItemAttachment(modifiedFile, response, file.name)
        );
      }

      return true;
    })
    .catch((error: unknown) => {
      const errorMessage = this.getErrorMessage(error, 'An error occurred while uploading the file');
      // Display the specific error message from the API
      this.messageService.add({
        severity: ActionItemConstants.Severity_Err,
        summary: `Failed to upload file: ${file.name}`,
        detail: errorMessage,
        sticky: true
      });

      return false;
    });
}

  determineAction(hasUploadFailures: boolean = false){
    this.keepSliderOpenAfterUpdate = this.isEditSlider && hasUploadFailures;
    if(this.isEditSlider)
      this.validateUsersForActionItemUpdate();
    else
      this.updateActionItem();
  }

  async saveActionItem() {
    this.validateActionItemForm();    
    if (this.errorMessages.length == 0) {
      // Verifier only updates must be justified with a reason which is tracked in the Audit Trail
      if (this.isVerifierOnlyEdit && !this.checkValidity(this.reasonForChange?.trim())) {
        this.isReasonForChangeRequired = true;
        return;
      }
      this.actionItemSliderLoader = true;      
      if(this.event == ActionItemConstants.ActionItem_SpeedDialButton_Edit || this.event == ActionItemConstants.ActionItem_SpeedDialButton_EditForAssignee){
        this.mapActionItemToUpdate(); // Map Action item Updated data before update call

        if(this.hasDuplicateAttachmentNames()){
          this.actionItemSliderLoader = false;
          return;
        }

        // Remove deleted attachments from storage first so reupload with the same name does not conflict with the old file.
        this.deleteActionItemFilesFromStorage().subscribe(() => {
          this.deletedAttachmentFileIds = [];
          if(this.attachmentsToSave != null && this.attachmentsToSave.length > 0){
            this.saveFiles();
          }
          else{
            this.validateUsersForActionItemUpdate();
          }
        });
        return;
      }
      else{  
        this.mapActionItemFormToActionPlanForCreate();
        if(this.attachmentsToSave != null && this.attachmentsToSave.length > 0) {
          await this.uploadDocuments();        
        } else {
          this.saveActionPlan();
        }
      }      
    }
  }

  // Blocks save when a new file name matches a visible attachment.
  private hasDuplicateAttachmentNames(): boolean {
    const duplicateFiles = this.attachmentsToSave.filter((file) =>
      this.extendActionItem.attachments?.some((data: any) => data.attachmentName === file.name)
    );

    if (duplicateFiles.length > 0) {
      duplicateFiles.forEach((duplicateFile) => {
        this.messageService.add({
          severity: ActionItemConstants.Severity_Err,
          summary: `${ActionItemConstants.Failed_To_Upload_File}: ${duplicateFile.name}`,
          detail: ActionItemConstants.Duplicate_File_Name_Error,
          sticky: true
        });
      });
      return true;
    }
    return false;
  }

  validateUsersForActionItemUpdate(){

    this.inactiveUserSelected = undefined;
    this.inactiveGroupsSelected = undefined;
    this.inactiveGroupsSelected = this.assignmentGroupSharedDataService.findInactiveObjectsInValidatedList(this.actionItemForm.value,this.validatedUsersList,
      this.usersList
    );
    if(this.inactiveGroupsSelected != undefined && this.inactiveGroupsSelected.length > 0){
      this.isInActiveAssignmentGroupDialog = true;   
      this.InactiveAssignmentGroupField = this.inactiveGroupsSelected;
     }
     else{
      this.updateActionItem(this.keepSliderOpenAfterUpdate); // Update API call
     }
  }
  
  saveAssignmentGroupwithInactiveUsers(){
    this.isInActiveAssignmentGroupDialog = false;
    this.updateActionItem(this.keepSliderOpenAfterUpdate);
  }

  async closeConfirmationDailog(value : boolean){    
  this.isInActiveAssignmentGroupDialog = value
  // const eQMSScopes = this.changeControlForm.getRawValue().eQMSScopes;
  // await this.loadUserList(eQMSScopes);
  // await this.populateChangeControlDetailsForEdit();
  // this.patchValueForChangeControl(this.changeControlDetails);
  }



  async uploadDocuments() {
    this.uploadResponses = [];
    this.actionItemFilesResponses = [];
    let ifUploadFailed = false;
    this.generateNumberForActionItems(); // Generate Action Item Number for each action item
    for (const [aiIndex, actionItem] of this.actionItemsRequest.ActionItems.entries()) {
        for (const [index, file] of this.attachmentsToSave.entries()) {
            await this.uploadFile(file, actionItem, index, aiIndex, ifUploadFailed).catch(() => {
                ifUploadFailed = true; // Set failure status on error
            });
        }
    }

    // Show error message if any upload failed
    if (ifUploadFailed) {
        const validationMessage = ActionItemConstants.File_Upload_Failed.replace(
            'Name', ActionItemConstants.ActionItemAttachments
        );
        this.messageService.add({
            severity: ActionItemConstants.Severity_Err,
            summary: validationMessage,
            sticky: true
        });
    }

    // Finally, save the action plan
    this.saveActionPlan();
}

generateNumberForActionItems(){
  if(this.lastActionItemNumber != null && this.lastActionItemNumber != undefined && this.lastActionItemNumber != ''){
    this.actionItemsRequest.ActionItems.forEach((actionItem: any) => {
      actionItem.ActionItemNumber = this.lastActionItemNumber!.slice(0, -1) + (parseInt(this.lastActionItemNumber!.slice(-1)) + 1);
      this.lastActionItemNumber = this.lastActionItemNumber!.slice(0, -1) + (parseInt(this.lastActionItemNumber!.slice(-1)) + 1)
    });
  }
  else{
    this.actionItemsRequest.ActionItems.forEach((actionItem: any, index: number) => {
      actionItem.ActionItemNumber = this.changeControlNumber + '-00' + (index + 1);
    });
  }

}

async uploadFile(file: File, actionItem: any, index: number, aiIndex: number, ifUploadFailed: boolean) {
  return new Promise((resolve, reject) => {
    const modifiedFile = new File(
      [file], 
      actionItem.ActionItemNumber + '/' + file.name, 
      { type: file.type }
    );
    
    this.actionPlanService.uploadFile(
      modifiedFile, 
      ActionItemConstants.ActionItem_Attachments_FolderName
    ).subscribe({
      next: (response: any) => {
        actionItem.Attachments = actionItem.Attachments || [];
        const attachment = {
          attachmentFileType: response.fileExtension,
          fileId: response.fileId,
          attachmentFilePath: modifiedFile.name,
          attachmentFileName: file.name,
        };
        actionItem.Attachments.push(attachment);
        resolve(actionItem);
      },
      error: (err: unknown) => {
        const errorMessage = this.getErrorMessage(err, SharedConstants.UnAuthorized_File_Upload_Error);
        // Show specific error message for this file
        this.messageService.add({
          severity: ActionItemConstants.Severity_Err,
          summary: `Failed to upload file: ${file.name}`,
          detail: errorMessage,
          sticky: true
        });
        
        reject({ 
          file, 
          actionItem, 
          error: errorMessage 
        });
      }
    });
  });
}

  private getErrorMessage(error: unknown, fallbackMessage: string): string {
    if (typeof error === 'string' && error.trim().length > 0) {
      return error;
    }

    if (error && typeof error === 'object') {
      const candidate =
        (error as any).message
        || (error as any).error?.errorMessage
        || (error as any).error?.detail
        || (error as any).error;

      if (typeof candidate === 'string' && candidate.trim().length > 0) {
        return candidate;
      }
    }

    return fallbackMessage;
  }

  chunkArray = (array: any, chunkSize: number) => {
    const numberOfChunks = Math.ceil(array.length / chunkSize)
     
    return [...Array(numberOfChunks)]
      .map((value, index) => {
        return array.slice(index * chunkSize, (index + 1) * chunkSize)
      })
  }

  saveActionPlan() {
    // call the action item service to save the action items into database
    this.actionPlanService.saveActionPlan(this.actionItemsRequest)
      .pipe(
        switchMap((actionPlan) => {
          this.actionPlanId = actionPlan.actionPlanId;
          this.actionItemIds = actionPlan.actionItems.map((item: any) => item.actionItemId);
          return this.actionPlanService.getCreatedActionPlanAndActionItems(this.actionPlanId, this.actionItemIds)
            .pipe(
              map((resp: any) => {
                if (resp == null) {                  
                  throw new CustomError("Action items were not created");
                }
                else
                  return resp;
              }),
              retry({
                count: 5,
                delay: (error, retryCount) => {
                  if (retryCount >= 5) {
                    return throwError(() => error);
                  }
                  return timer(3000); // wait 3 seconds before retrying
                }
              })
            );
        })
      )
      .subscribe({
        next: (resp) => {
          this.closeActionItemSlider.emit();
          this.isSliderActive.emit(false);
          this.actionItemSliderLoader = false; 
          this.messageService.add({
            severity: 'success',
            summary: `${ActionItemConstants.ActionItem_AddActionItems_Success}`,
          });
          this.attachmentsUploaded = [];
          this.resetActionItemForm();          
          this.changeControlPersistenceService.actionPlanDataUpdated.next(true);
        },
        error: (error) => {
          this.changeControlPersistenceService.actionPlanDataUpdated.next(true);
          let message = ActionItemConstants.ActionItem_AddActionItems_Failure;
          if (error instanceof CustomError) {
            message = ActionItemConstants.ActionItem_Creation_TechnicalError;
          }
          else {
            this.closeActionItemSlider.emit();
            this.isSliderActive.emit(false);
            //delete uploaded attachments
          this.attachmentsUploaded = [];
          this.resetActionItemForm();
          }
          this.actionItemSliderLoader = false; 
          this.messageService.add({
            severity: 'error',
            summary: message,
            sticky: true
          });
          
          
        }
      });
    }

  mapActionItemFormToActionPlanForCreate() {
    let formValues = this.actionItemForm.getRawValue();
    this.actionItemsRequest = new ChangeControlActionPlan();
    this.actionItemsRequest.ChangeControlNumber = this.changeControlNumber;
    this.actionItemsRequest.ActionItems = [];
    formValues.assignees.forEach((assignee: any) => {
      let actionItem = new ChangeControlActionItem();
      actionItem.Title = formValues.title;
      actionItem.Type = formValues.type;
      actionItem.Description = formValues.description;
      actionItem.DueDate = (formValues.dueDate !== null && formValues.dueDate !== undefined) ? this.commonService.conversionOfDateIntoLocalDateTime(new Date(formValues.dueDate)) : null;

      actionItem.IsRiskAssessmentRequired = formValues.isRiskAssessmentRequired;
      actionItem.IsVerificationRequired = formValues.isVerificationRequired;
      actionItem.Assignee = assignee; 
      actionItem.Verifier = formValues.verifier;
      actionItem.ActionTaken = formValues.actionTaken;
      actionItem.VerificationNotes = formValues.verificationNotes;      
      this.actionItemsRequest.ActionItems.push(actionItem);
    })
    //this.actionItemsRequest.Attachments = this.attachmentsUploaded
  }

  mapActionItemToUpdate(){
    let formValuesForEdit = this.actionItemForm.getRawValue(); // get form values and map with extend Action item
    this.extendActionItem.changeControlNumber = this.actionItemDetails.changeControlNumber;
    this.extendActionItem.reason = this.checkValidity(this.reasonForChange) ? this.reasonForChange : null;
    // as source status is not being updated through an update call and its a mandotory filed, hence setting as 0
    this.extendActionItem.sourceStatus = this.actionItemDetails.status == null ? 0 : this.actionItemDetails.status; 
    this.extendActionItem.targetStatus = null;
    this.extendActionItem.event = ActionItemConstants.ActionItem_Edit_ActionItemUpdate;
    this.extendActionItem.actionItemNumber = this.actionItemDetails.actionItemNumber;
    this.extendActionItem.actionItem = formValuesForEdit.title;
    this.extendActionItem.actionType = formValuesForEdit.type;
    this.extendActionItem.description = formValuesForEdit.description;
    this.extendActionItem.dueDate = (formValuesForEdit.dueDate !== null && formValuesForEdit.dueDate !== undefined) ? this.commonService.convertDateIfChanged(new Date(formValuesForEdit.dueDate), new Date(this.actionItemDetails?.dueDate as Date)) : null;
    this.extendActionItem.riskAssesmentRequired = formValuesForEdit.isRiskAssessmentRequired;
    this.extendActionItem.verificationRequired = formValuesForEdit.isVerificationRequired;
    this.extendActionItem.status = this.actionItemDetails.status;
    this.extendActionItem.assignedUser = formValuesForEdit.assignees;
    this.extendActionItem.verifier = formValuesForEdit.verifier;
    this.extendActionItem.actionTaken = formValuesForEdit.actionTaken;
    this.extendActionItem.verifierNotes = formValuesForEdit.verificationNotes;      
    this.extendActionItem.attachments = this.attachmentData; // no file Uploaded, hence mapping old file
  }

  async setDataForEdit(){
    this.sliderHeaderText = ChangeManagementConstant.EditActionItem_Title;
    await this.initializeUserList();
    // If the call is made for Edit
    if(this.checkValidity(this.actionItemDetails)){
      // patch value(s) with Form Controls

      this.actionItemForm.patchValue({
        title: this.actionItemDetails?.actionItem != null ? this.actionItemDetails?.actionItem.substring(this.actionItemDetails?.actionItem.indexOf(' ') + 1)  : null,
        type: this.actionItemDetails?.actionType,
        description: this.actionItemDetails?.description,
        dueDate: new Date(this.actionItemDetails?.dueDate as Date),
        isRiskAssessmentRequired: this.actionItemDetails?.riskAssesmentRequired,
        isVerificationRequired: this.actionItemDetails?.verificationRequired,
        verificationNotes: this.actionItemDetails?.verifierNotes,
        actionTaken: this.actionItemDetails?.actionTaken,
        assignees: this.actionItemDetails?.assignedUser,
      });

      // to enable Verifier
      if(this.checkValidity(this.actionItemDetails?.verificationRequired) && this.actionItemDetails?.verificationRequired == true){
        this.verificationCheckboxChange();
        this.actionItemForm.patchValue({
          verifier: this.checkValidity(this.actionItemDetails?.verifier) ? this.actionItemDetails?.verifier : null,
        })
      }

      // If edit clicked for assignee, need everything disable except Action taken & Attachment
      if(this.event == ActionItemConstants.ActionItem_SpeedDialButton_EditForAssignee){
        this.actionItemForm.controls['title'].disable();
        this.actionItemForm.controls['type'].disable();
        this.actionItemForm.controls['description'].disable();
        this.actionItemForm.controls['dueDate'].disable();
        this.actionItemForm.controls['isRiskAssessmentRequired'].disable();
        this.actionItemForm.controls['isVerificationRequired'].disable();
        this.actionItemForm.controls['verifier'].disable();
        this.actionItemForm.controls['verificationNotes'].disable();
        this.actionItemForm.controls['assignees'].disable();
      }

      this.setVerifierOnlyEditMode();
      this.isEditSlider = true; // map for Togellaing between Multi select to Single Select for Assignee
      this.attachmentData = this.actionItemDetails?.attachments;
      this.deletedAttachmentFileIds = [];
    }
  }


  async initializeUserList(){
      this.verifiersList=[];
      this.assigneeList=[];
      this.verifiersWithInactiveUsersList=[];
      this.assigneeWithInactiveUsersList=[];

      this.verifiersList=[...this.usersList];
      this.assigneeList=[...this.usersList];
      this.verifiersWithInactiveUsersList=[...this.usersList];
      this.assigneeWithInactiveUsersList=[...this.usersList];

      this.usersListToValidate=[];

      let assignedUsersList: any=[];
      assignedUsersList.push(this.actionItemDetails.assignedUserInfo);
      let verifiersList: any=[];
      verifiersList.push(this.actionItemDetails.verifierInfo);

      this.usersListToValidate.push({
        userType:UserType.ACAssignees,
        userAssignmentList: assignedUsersList
       });
       this.usersListToValidate.push({
        userType:UserType.ACVerifiers,
        userAssignmentList: verifiersList
       });
       
        // Fetch and process the validated users list
        this.validatedUsersList = await firstValueFrom(this.usersService.validateUsers(this.usersListToValidate));
        this.changeControlPersistenceService.acValidatedUsersList = this.validatedUsersList;

        if (this.validatedUsersList.length > 0) {
          // Iterate through each userInfo in the validatedUsersList
          this.validatedUsersList.forEach((userInfo: { userAssignmentList: any[]; userType: any; }) => {
              // Filter only inactive user types for binding dropdown lists
              const filteredAssignments = userInfo.userAssignmentList.filter(assignment => assignment.assignmentType != 0);
      
              // Determine the target list based on user type
              let targetList: { name: string, value: string }[] = [];
      
              switch (userInfo.userType) {
                  case UserType.ACAssignees:
                      targetList = this.assigneeWithInactiveUsersList;
                      break;
                  case UserType.ACVerifiers:
                      targetList = this.verifiersWithInactiveUsersList;
                      break;
                  default:
                      return; // Skip unknown user types
              }
      
              // Add filtered assignments to the target list
              filteredAssignments.forEach(user => {
                  const userItem = { name: user.assignedUserName, value: user.assignedUserName };
      
                  // Check if the item already exists in the target list
                  if (!targetList.some(item => item.name === userItem.name && item.value === userItem.value)) {
                      targetList.push(userItem);
                  }
              });
          });
      this.assigneeList=[...this.assigneeWithInactiveUsersList];
      this.verifiersList=[...this.verifiersWithInactiveUsersList];
    }
  }


  resetActionItemForm() {
    this.actionItemsRequest = new ChangeControlActionPlan();
    this.actionItemForm.reset();
    this.deletedAttachmentFileIds = [];
    this.reasonForChange = '';
    this.isReasonForChangeRequired = false;
  }

  // An Action Item waiting for verification can only have its Verifier changed
  private setVerifierOnlyEditMode() {
    this.isVerifierOnlyEdit = this.event == ActionItemConstants.ActionItem_SpeedDialButton_Edit
      && this.actionItemDetails?.status == ActionItemStatus.Verify;

    if (!this.isVerifierOnlyEdit) {
      return;
    }

    Object.keys(this.actionItemForm.controls)
      .filter(controlName => controlName !== ActionItemConstants.ActionItem_VerifierRole)
      .forEach(controlName => this.actionItemForm.controls[controlName].disable());

    this.actionItemForm.controls[ActionItemConstants.ActionItem_VerifierRole].enable();
    this.isVerifierRequired = true;
  }

  closeReasonDialog(isOpen: boolean) {
    this.isReasonForChangeRequired = isOpen;
  }

  saveActionItemWithReason(reason: string) {
    const trimmedReason = reason?.trim() ?? '';
    if (!this.checkValidity(trimmedReason)) {
      // The shared dialog only checks length, so whitespace-only input must be rejected here
      if (this.reasonDialog) {
        this.reasonDialog.isReasonForDocumentUpdateRequired = true;
      }
      return;
    }
    this.reasonForChange = trimmedReason;
    this.isReasonForChangeRequired = false;
    this.saveActionItem();
  }

  private validateActionItemForm() {
    this.errorMessages = [];
    this.mandatoryFields = this.getDefaultMandatoryFieldsObject();
    if (this.actionItemForm.invalid) {
      Object.keys(this.actionItemForm.controls).forEach(key => {
        if (this.actionItemForm.get(key)?.errors) {
          let errorText = this.getErrorMessageText(key);
          if(errorText != "")
          this.errorMessages.push(errorText);
        }
      });
    }
    this.validateAssigneesAndVerifiers();
  }

  validateAssigneesAndVerifiers() {
    let assignees = this.actionItemForm?.getRawValue().assignees;
    let verifier = this.actionItemForm?.getRawValue().verifier;
    // Assignee is a single value on edit and a list on create
    let assigneeList = Array.isArray(assignees) ? assignees : this.checkValidity(assignees) ? [assignees] : [];
    if (verifier && assigneeList.indexOf(verifier) !== -1) {
      this.errorMessages.push(ActionItemConstants.ActionItem_Same_AssigneeNVerifier);
    }
  }

  private getDefaultMandatoryFieldsObject() {
    return {
      title: false,
      type: false,
      dueDate: false,
      assignees: false,
      verifier: false,
    };
  }
  private getErrorMessageText(labelName: string) {
    let errorText: string = "";
    let formValues = this.actionItemForm.getRawValue();
    switch (labelName) {
      case 'title':
        errorText = ActionItemConstants.ActionItem_Title_Required;
        this.mandatoryFields.title = true;
        break;
      case 'type':
        errorText = ActionItemConstants.ActionItem_Type_Required;
        this.mandatoryFields.type = true;
        break;
      case 'assignees':
        errorText = ActionItemConstants.ActionItem_Assignees_Required;
        this.mandatoryFields.assignees = true;
        break;
      case 'verifier':
        if(formValues.isVerificationRequired) {
          errorText = ActionItemConstants.ActionItem_Verifier_Required;
          this.mandatoryFields.verifier = true;
        }        
        break;
      case 'dueDate':
        errorText = ActionItemConstants.ActionItem_DueDate_Required;
        this.mandatoryFields.dueDate = true;
        break;
    }
    return errorText;
  }

  verificationCheckboxChange() {
    let formValues = this.actionItemForm.getRawValue();
    if (formValues.isVerificationRequired) {
      this.actionItemForm.controls['verifier'].enable();
      this.actionItemForm.controls['verificationNotes'].enable();
      this.isVerifierRequired = true;
    } else {
      this.actionItemForm.controls['verifier'].disable();
      this.actionItemForm.get('verifier')!.setValue(null);
      this.actionItemForm.controls['verificationNotes'].disable();
      this.actionItemForm.get('verificationNotes')!.setValue(null);
      this.isVerifierRequired = false;
    }
  }

  checkValidity(val : any) : boolean {
    return val != null && val != undefined && val != '';
  }

  // Update Action Item from Edit Slider
  updateActionItem(keepSliderOpenAfterSuccess: boolean = false) {
    this.deleteActionItemFilesFromStorage().subscribe({
      next: () => {
        // call the action item service to Update the action items into database
        this.actionPlanService.updateActionItem(this.extendActionItem).subscribe({
          next: (resp) => {
              this.actionItemSliderLoader = false;
              if (keepSliderOpenAfterSuccess) {
                this.attachmentData = this.extendActionItem.attachments;
                this.deletedAttachmentFileIds = [];
                return;
              }
              this.closeActionItemSlider.emit();
              this.messageService.add({
                severity: 'success',
                summary: `${ActionItemConstants.ActionItem_UpdateActionItems_Success}`,
              });
              this.attachmentsUploaded = [];
              this.resetActionItemForm();
              this.isSliderActive.emit(false);
              this.updatedActionPlan.emit(resp);
          },
          error: () => {
            this.actionItemSliderLoader = false;
            this.messageService.add({
              severity: 'error',
              summary: ActionItemConstants.ActionItem_UpdateActionItems_Failure,
            });
            //delete uploaded attachments
            this.closeActionItemSlider.emit();
            this.attachmentsUploaded = [];
            this.resetActionItemForm();
            this.isSliderActive.emit(false);
          }
        });
      },
      error: () => {
        this.actionPlanService.updateActionItem(this.extendActionItem).subscribe({
          next: (resp) => {
              this.actionItemSliderLoader = false;
              if (keepSliderOpenAfterSuccess) {
                this.attachmentData = this.extendActionItem.attachments;
                this.deletedAttachmentFileIds = [];
                return;
              }
              this.closeActionItemSlider.emit();
              this.messageService.add({
                severity: 'success',
                summary: `${ActionItemConstants.ActionItem_UpdateActionItems_Success}`,
              });
              this.attachmentsUploaded = [];
              this.resetActionItemForm();
              this.isSliderActive.emit(false);
              this.updatedActionPlan.emit(resp);
          },
          error: () => {
            this.actionItemSliderLoader = false;
            this.messageService.add({
              severity: 'error',
              summary: ActionItemConstants.ActionItem_UpdateActionItems_Failure,
            });
            //delete uploaded attachments
            this.closeActionItemSlider.emit();
            this.attachmentsUploaded = [];
            this.resetActionItemForm();
            this.isSliderActive.emit(false);
          }
        });
      }
    });
  }

  private deleteActionItemFilesFromStorage(): Observable<string[]> {
    if (!this.deletedAttachmentFileIds || this.deletedAttachmentFileIds.length === 0) {
      return of([]);
    }

    return forkJoin(
      this.deletedAttachmentFileIds.map((fileId) =>
        this.actionPlanService.deleteFile(fileId).pipe(
          map(() => fileId),
          catchError((error) => {
            console.error('Error deleting action item attachment from storage:', fileId, error);
            return of('');
          })
        )
      )
    ).pipe(
      map((deletedFileIds) => deletedFileIds.filter((fileId) => fileId !== ''))
    );
  }

  // download attachment while re directing to new screen
  downloadAttachment = (fileId: string, fileName: string) => {
    this.actionPlanService.downloadFile(fileId).subscribe((response) => {
      const fileUrl = response.fileUri;
      let downloadLink = document.createElement('a');
      document.body.appendChild(downloadLink);
      downloadLink.setAttribute('style', 'display: none');
      downloadLink.href = fileUrl;
      downloadLink.download = fileName;
      downloadLink.target = '_blank';
      downloadLink.click();
      downloadLink.remove();
    })
  }

  constructActionItemAttachment = (file: File, fileSaveResponse: any, fileName : string): any => {
    return {
      fileId: fileSaveResponse.fileId,
      attachmentName: fileName,
      attachmentType: fileSaveResponse.fileExtension,
      attachmentPath: fileSaveResponse.filePath
    }
  }

  deleteAttachment(attachmentId:string){
    if (this.deletedAttachmentFileIds.indexOf(attachmentId) === -1) {
      this.deletedAttachmentFileIds.push(attachmentId);
    }
    this.attachmentData = Array.isArray(this.attachmentData)
      ? this.attachmentData.filter((key :any) => key.fileId != attachmentId)
      : [];
  }

  updateScopesOnChangeControlUpdate(scopes: number[] | null){
    if(scopes != null){
      this.scopes = scopes;
      this.getUserLookUpData(scopes, true);
    }
  }
}
